import { toDate as o } from "./toDate.js";
import { constructFrom as a } from "./constructFrom.js";
function u(r) {
  const e = o(r), t = a(r, 0);
  return t.setFullYear(e.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
export {
  u as default,
  u as startOfYear
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/startOfYear.js
// module id = 456
// module chunks = 67